import i18n from '../../locales/index'
import restful from '../vuex'
import { Message } from 'view-design'
import axios from 'axios';

const state = {
  ...restful.states('bill')
}

const getters = {
  ...restful.getters('bill'),
  aggregate_test: (state) =>
    i18n.t('store_modules_bill_1316', [state.meta.first,state.meta.second])
}

const actions = {
  ...restful.actions('bills'),
  async billPay ({ commit }, params) {
    await axios.post(`bills/${params.id}/pay`, params)
    Message.success(i18n.t('store_modules_bill_1317'))
  },
}

const mutations = {
  ...restful.mutations('bill')
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
